module.exports = __webpack_public_path__ + "static/media/message-circle.ebbe6d9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/message-circle.svg
// module id = 910
// module chunks = 0